var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Id } from "core/utils";
import { colors } from "core/styles/snippets";
import { Banner } from "common/Banner/components/Banner";
import Exclamation from "core/components/Icon/icons/Exclamation";
export var ErrorBanner = function (_a) {
    var children = _a.children, className = _a.className, onClose = _a.onClose;
    return (React.createElement(StyledBanner, { className: className, onClose: onClose, "data-component": Id.component.banner.error },
        React.createElement(StyledExclamation, { color: colors.white }),
        " ",
        children));
};
var StyledBanner = styled(Banner)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), colors.roseRed);
var StyledExclamation = styled(Exclamation)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 0.5625rem;\n"], ["\n  margin-right: 0.5625rem;\n"])));
var templateObject_1, templateObject_2;
